import script from "./DoaAttestationComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoaAttestationComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DoaAttestationComponent.vue?vue&type=style&index=0&id=4957dfcc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4957dfcc"]])

export default __exports__